import ChipColors from './ChipColors';

export default [
  {
    text: 'Usuário',
    value: 'Usuario',
    ...ChipColors.light,
  },
  {
    text: 'Dispositivo',
    value: 'Device',
    ...ChipColors.wait,
  },
];
